<template>
  <div>
    <div class="page">
      <Modal v-model="activeModal" title="Excelente">
        <p>Haz Finalizado el Curso satisfactoriamente </p>
        <p>Prueba nuestro editor de codigo: <a href="/#/code/edit">Aqui</a></p>
        <button type="button" class="btn btn-primary" @click="goTodpath('/certificate/'+certPath)">
          Ver certificado
        </button>
      </Modal>

      <Modal v-model="loading" title="Cargando">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </Modal>


      <option-modal v-if="showOptions" @close="showOptions = false"></option-modal>
      <div  class="left-container" :class="{ hide: !showHtml && !showJS }"
            @mousemove="onDragging"
            @mouseup="onDragEnd"
            @mouseleave="onDragEnd('leave')"
            :style="{ 'flex-basis': leftWidth }"
      >
            <vue-scrollbar class="my-left-scrollbar">
              <div  class="left-into-container"
                    @mousemove="onDragging"
                    @mouseup="onDragEnd"
                    @mouseleave="onDragEnd('leave')"
                    :style="{ 'flex-basis': leftWidth }"
              >
                  <div  class="kichwa-container" :class="{ hide: !showJS }" :style="{ 'flex-basis': `calc(100% - ${htmlHeight})` }">
                        <code-editor class="editor" :enable="true" :value="kichwaStr" mode='kichwa' title='Kichwa' @update="value => kichwaStr = value"></code-editor>
                  </div>
                <div class="separator separator-vertical" @mousedown="onDragStart('left')"></div>


              </div>

            </vue-scrollbar >

            <div class="my-tab-view">
              <div class="container">
                <div class="tab-pane fade" :class="{ 'active show': isActive('run') }" >

                </div>
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item" v-if="isCourse" >
                    <a class="nav-link"  @click.prevent="setActive('course')" :class="{ active: isActive('course') }" href="#course">Progreso del Estudante</a>
                  </li>
                  <li class="nav-item" v-if="!isCourse"  >
                    <a class="nav-link" @click.prevent="setActive('run')" :class="{ active: isActive('run') }" href="#run">Panel de Activades</a>
                  </li>
                  <li class="nav-item"  v-if="isCourse" >
                    <a class="nav-link" @click.prevent="setActive('help')" :class="{ active: isActive('help') }" href="#help">Documentacíon</a>
                  </li>
                </ul>
                <div class="tab-content py-3" id="myTabContent">
                  <div class="tab-pane fade" :class="{ 'active show': isActive('run') }" id="run">
                    <div class="row">
                      <div  v-if="errorStatus" >
                        {{errorTerm}}
                      </div>
                      <div class="card col-sm" style="width: 18rem;">
                        <div class="card-body ">
                            <div class="bt-container">
                              <img class="option-btn" data-toggle="tooltip" data-placement="top" title="Vaciar Editor"  src="../../assets/images/clean.png" v-on:click="clearEditor">
                              <p>Vaciar </p>
                            </div>
                        </div>
                      </div>
                      <div class="card col-sm" style="width: 18rem;">
                        <div class="card-body ">
                          <div class="bt-container">
                            <img class="option-btn"  data-toggle="tooltip" data-placement="top" title="Traducir Codigo"  src="../../assets/images/code.png" v-on:click="translateCode">
                            <p>Traducir</p>
                          </div>
                        </div>
                      </div>
                      <div class="card col-sm" style="width: 18rem;">
                        <div class="card-body">
                          <div class="bt-container">
                            <img class="option-btn"  data-toggle="tooltip" data-placement="top" title="Ejecutar Codigo" src="../../assets/images/term.png" v-on:click="runTerm">
                            <p>Compilar </p>
                          </div>
                        </div>
                      </div>
                      <div class="card col-sm" style="width: 18rem;">
                        <div class="card-body">
                          <div class="bt-container">
                            <img class="option-btn" data-toggle="tooltip" data-placement="top" title="Opciones" src="../../assets/option.png" @click="showOptions = true">
                            <p>Opciones </p>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="tab-pane fade" :class="{ 'active show': isActive('course') }" id="course">
                    <div  v-if="errorStatus" >
                      {{errorTerm}}
                    </div>
                    <div v-for="(level, index) in levels"  :key="level.id">
                      <CourseLevel  :progress-course="course.percentProgress" :level="level" :index="index+1"  v-if="inProgress(level.status)" />
                      <div class="container">
                        <div class="row" v-if="inProgress(level.status)" >
                          <div class="col-sm">
                            <img class="option-btn" data-toggle="tooltip" data-placement="top" title="Vaciar Editor"  src="../../assets/images/clean.png" v-on:click="clearEditor">
                          </div>
                          <div class="col-sm">
                            <img class="option-btn"  data-toggle="tooltip" data-placement="top" title="Traducir Codigo"  src="../../assets/images/code.png" v-on:click="translateCode()">
                           </div>
                          <div class="col-sm">
                            <img class="option-btn"  data-toggle="tooltip" data-placement="top" title="Ejecutar Codigo" src="../../assets/images/term.png" v-on:click="runTerm">
                          </div>
                          <div class="col-sm">
                            <img class="option-btn"   data-toggle="tooltip" data-placement="top" title="Continuar" src="../../assets/images/play.png" v-on:click="nexLevel(index)">
                          </div>
                          <div class="col-sm">
                            <img class="option-btn" data-toggle="tooltip" data-placement="top" title="Opciones" src="../../assets/option.png" @click="showOptions = true">

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="tab-pane fade" v-if="isCourse"  :class="{ 'active show': isActive('help') }" id="help">
                   <vue-scrollbar class="my-help-scrollbar">
                     <h1 >
                       {{ docIndex+1+".- "+doc.title}}
                     </h1>
                     <div >
                       <div>
                         <p>
                           {{doc.description}}
                         </p>
                       </div>
                       <div class="doc-image-ctner">
                         <img  class="doc-image"  :src="getImgUrl(doc.id)" v-bind:alt="pic">
                       </div>
                       <br>
                     </div>
                   </vue-scrollbar>

                  </div>
                </div>

              </div>
            </div>
      </div>
      <div class="separator separator-horizotal" @mousedown="onDragStart('middle')" @mouseup="onDragEnd"></div>
       <div class="right-container" :class="{ hide: !showCSS && !showPreview }"
             @mousemove="onDragging"
             @mouseup="onDragEnd"
             @mouseleave="onDragEnd('leave')"
             :style="{ 'flex-basis': `calc(100% - ${leftWidth})` }"
        >
             <vue-scrollbar class="my-right-scrollbar">
                <div class="my-code-view">
                  <div class="my-python-code">
                    <span class="panel-python-title" v-show="true">{{ "python" }}</span>
                          <pre  class="my-python-code"  >
                            <code v-html="yourPythonCode"></code>
                          </pre>
                  </div>
                </div>

             </vue-scrollbar>
             <div class="separator separator-vertical" @mousedown="onDragStart('right')" @mousemove="onDragging"></div>
             <div class="iframe-container"  :style="{ 'flex-basis': `calc(100% - ${cssHeight})` }">
               <html-preview
                   ref='htmlPreview'
                   :output="yourOutput.toString()"
                   :error="errorTerm"
                  >
               </html-preview>
             </div>

       </div>



    </div>
  </div>
</template>

<script>

import codeEditor from './Editor.vue'
import CourseLevel from "@/components/EditorComponent/Course/CourseLevel";
import htmlPreview from './Preview.vue'
import CodeStorage from '../../utils/code-storage.js'
import store from '../../store'
import VueScrollbar from 'vue2-scrollbar';
import constants from "@/utils/constants";
import axios from "axios";
const optionModal = () => import('./Option.vue')

let lastActiveElement
require("../../assets/style/vue2-scrollbar.css")

export default {
  name: 'EditorPage',
  store,
  props:{
    isCourse:Boolean
  },
  data: function () {
    return {
      certPath:'',
      user:{},
      course:{},
      levels:[],
      runtimeCompiler:'PYTHON',
      errorTerm: '',
      cssStr: '',
      pythonStr:"",
      kichwaStr: '',
      htmlHeight: '50%',
      cssHeight: '50%',
      leftWidth: '50%',
      yourPythonCode: ``,
      yourOutput:'',
      yourInput:'',
      activeItem: this.isCourse?'course':'run',
      errorStatus:false,
      showHtml: true,
      showCSS: true,
      showJS: true,
      showPreview: true,
      enable:true,
      draggingSeparator: '',
      showOptions: false,
      activeModal:false,
      errorModal:false,
      loading:false,
      isLogin:false,
      errorText:'',
      errorTranslate:undefined,
      errorExe:undefined,
      actualIndex:0,
      translateTry:0,
      docs:[],
      doc:{},
      docIndex:0
    }
  },
  components: {
    CourseLevel,
    VueScrollbar,
    codeEditor,
    htmlPreview,
    optionModal
  },
  mounted: function () {
    const allItems = CodeStorage.fetchAll()
    for (let key in allItems) {
      this[key] = allItems[key]
    }

    setTimeout(() => {
      this.render()
    }, 600)

    document.onkeydown = this.onKeyDown
  },
  watch: {
    htmlStr: function () { CodeStorage.save({ htmlStr: this.htmlStr || '' }) },
    cssStr: function () { CodeStorage.save({ cssStr: this.cssStr || '' }) },
    jsStr: function () { CodeStorage.save({ jsStr: this.kichwaStr || '' }) }
  },
  methods: {
    clearEditor:function (){
      this.yourPythonCode='';
      this.kichwaStr='';
      this.pythonStr='';
      this.errorTerm='';
      this.yourOutput='';
      this.errorStatus=false;
      this.docIndex=0
      this.doc=this.docs[this.docIndex];
    },
    goTodpath:function (path){
      this.$router.push(path);
    },
    getImgUrl(pic) {
      return require("../../assets/images/"+pic+".png");
    },
    getDocs: function() {
      axios.get(constants.endpointList.docs,
      ).then((result)=>{
        this.docs=result.data;
        this.doc=this.docs[0];
        console.log(result);
      }).catch((error)=>{
        console.log(error);
      });

    },
    translateCode: function () {
      this.errorTranslate = undefined;
      this.yourPythonCode='';

      let actualCourse= undefined;
      if(this.isCourse)
        actualCourse =this.course.levels[this.actualIndex].title

      let post = {
        userId:  this.user.id,
        email: this.user.email,
        displayName:this.user.name,
        pseudoCode: this.kichwaStr,
        actualCourse:actualCourse,

        dateExecution:new Date().toISOString(),

      };
      this.loading=true;
      axios.post(constants.endpointList.kichwaTranslate, post).then((result) => {
        let postData = result.data.toString();
        this.errorTerm=undefined;
        this.loading=false;
        console.log(postData.includes('Error'));
        if(!postData.includes('Error')){
          this.yourPythonCode=postData;
        }else{
          this.loading=false;
          this.errorTerm=postData+". Revisa la documentacion.";
          this.errorTranslate=postData;
          this.errorStatus=true;
          this.errorTranslateTrack();
        }
      });

      this.docIndex=this.course.levels[this.actualIndex].doc;
      this.doc=this.docs[this.docIndex];
    },
    nexLevel:function (indexLevel){
      const actualLevel = this.levels[indexLevel];
      this.actualIndex = indexLevel;
      const result =this.yourOutput.split(" : ")[1];
      console.log("Level"+ result);
      const status_level = actualLevel.status === "IN_PROGRESS";
      const result_equals = result.includes(actualLevel.result)||result.isOnlyCompiled;
      const pattern_status = this.yourPythonCode.includes(actualLevel.patternValue);
      if( status_level
          && result_equals
        )
      {
        actualLevel.status="DONE";
        this.levels[indexLevel]=actualLevel;
        this.docIndex=actualLevel.doc;
        this.doc=this.docs[this.docIndex];

        if(indexLevel+1 < this.levels.length ){
          console.log("Entro "+indexLevel);

          this.levels[indexLevel+1].status="IN_PROGRESS";
          this.levels[indexLevel+1].progressLevel=actualLevel.id;
        }

        if(indexLevel+1 === this.levels.length){
          this.course.progressLevel="FINISH_COURSE"
          this.course.certificatePath=this.course.id+this.user.id;
          this.certPath = this.course.id+this.user.id;

        }



        this.course.percentProgress = (indexLevel+1)*100/this.levels.length;
        console.log(this.course);
        let post = {
          userId:  this.user.id,
          email: this.user.email,
          displayName:this.user.name,
          dateExecution:new Date().toISOString(),
          course:{
            ...this.course,
          }
        };
        this.loading=true;

        axios.put(constants.endpointList.nextLevel, post).then((result) => {
          let status = result.data.status;
          console.log("Level Update: "+status);
          this.loading=false;
          if(this.course.percentProgress ===100){
            this.activeModal = true;
            this.isCourse=false;
            this.activeItem='run';
          }
          this.createdCertificate();
        });

      }else{
        console.log("Err");
        this.loading=false;
        if(!status_level){
            console.log("error resultado no esperado")
          this.errorTerm="Error Revisa la terminal";

        }
        if(!result_equals){
          console.log("error resultado no esperado")
          this.errorTerm="Error Revisa la terminal";

        }
        if(!pattern_status){
          console.log("error de codio")
          this.errorTerm="Error Revisa la terminal";

        }
      }

    },
    createdCertificate:function (){
      this.loading=true;
      let post = {
        userId:  this.user.id,
        email: this.user.email,
        user:this.user.name,
        certificatePath:this.course.id+this.user.id,
        dateStamp:new Date().toISOString().replace('T',':').replace('Z,').replace('.',':'),
      };
      axios.post(constants.endpointList.complete, post).then((result) => {
        this.loading=false;
        let postData = result.data;
        console.log(postData)
        this.certPath=this.course.id+this.user.id;
       // this.goTodpath('/certificate/'+postData.certificatePath);

      });
    },
    errorTranslateTrack:function (){
      let post = {
        userId:  this.user.id,
        email: this.user.email,
        displayName:this.user.name,
        dateExecution:new Date().toISOString(),
        codeExecution:this.kichwaStr,
        error:this.errorTerm,
        type:'kichwa_error'
      };
      axios.post(constants.endpointList.kichwaError, post).then((result) => {
        let postData = result.data;
        this.yourOutput=`${postData.date} : ${postData.output}`;
        console.log(postData)

      });
    },

    runTerm:function () {
      let actualCourse= undefined;
      if(this.isCourse)
        actualCourse =this.course.levels[this.actualIndex].title
      let post = {
        userId:  this.user.id,
        email: this.user.email,
        displayName:this.user.name,
        pythonCode: this.yourPythonCode,
        actualCourse:actualCourse,
        dateExecution:new Date().toISOString(),
        errorData:this.errorTerm,
        input:this.yourInput,

      };
      axios.post(constants.endpointList.compileAndRun, post).then((result) => {
        let postData = result.data;
        this.yourOutput=`${postData.date} : ${postData.output}`;
        console.log(postData)

      });

    },

    onKeyDown: function (e) {
      if (!e.metaKey) return

      switch (e.key) {
        case '2': this.showJS = !this.showJS; break
        case '3': this.showCSS = !this.showCSS; break
        default: break
      }

      if (['1', '2', '3', '4', 'Enter'].indexOf(e.key) >= 0) {
        e.preventDefault()
      }
    },

    onDragStart: function (draggingSeparator) {
      lastActiveElement = document.activeElement
      this.draggingSeparator = draggingSeparator
    },
    inProgress:function (status){
      return status==="IN_PROGRESS";
    },
    onDragging: function (e) {
      if (this.draggingSeparator === 'left') {
        this.htmlHeight = e.y + 'px'
      } if (this.draggingSeparator === 'right') {
        this.cssHeight = e.y + 'px'
      } if (this.draggingSeparator === 'middle') {
        this.leftWidth = e.x + 'px'
      }
    },
    onDragEnd: function (source) {
      if (!this.draggingSeparator) return

      if (this.draggingSeparator !== 'middle' || source !== 'leave') {
        const map = {
          left: 'htmlHeight',
          right: 'cssHeight',
          middle: 'leftWidth'
        }
        const key = map[this.draggingSeparator]
        if (key) CodeStorage.save({ [key]: this[key] })

        this.draggingSeparator = ''
        if (lastActiveElement) lastActiveElement.focus()
      }
    },
    getUserLogin: function() {
      const userAuth =  JSON.parse(store.getters.getJWT);

      const bodyParameters = {
        email: userAuth.email
      };
      axios.post(constants.endpointList.getUser,
          bodyParameters,
      ).then((result)=>{
        this.user=result.data;

        if(this.isCourse) {
          this.getStudentCourse();

        }
      }).catch((error)=>{
        console.log(error);
      });

    },
    getStudentCourse:function (){
      const bodyParameters = {
        userId: this.user.id,
      };
      axios.post(constants.endpointList.courseStatus,
          bodyParameters,
      ).then((result)=>{
          this.course=result.data;
          this.levels=this.course.levels;
          if(this.course.percentProgress ===100){
           this.activeModal=true;
            this.isCourse=false;
            this.certPath=this.course.certificatePath;
            this.activeItem='run';
          }

      }).catch((error)=>{
        console.log(error);
        alert("Oh Parece que no estas matriculado en este curso ");
        this.goTodpath('/dashboard');
      });

    },
    render: function () {
      this.$refs.htmlPreview.render()
    },
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
  },
  created: function(){
    this.isLogin = this.$store.getters.isLogin;
    if(this.isLogin){
      this.loading=true;
      this.getDocs();
      this.getUserLogin();
      this.loading=false;
    }else{
      this.$router.push('/login');
    }
  }
}

</script>

<style scoped>



  .page {
    position: absolute;
    left: 0;
    top: 55px;
    width: 100%;
    height: 100vh;

    display: flex;
    flex-wrap: nowrap;
  }

  .left-container{
    flex-basis: 50%;
    flex-grow: 2;
    height: 100vh;

    flex-direction: column;
    flex-wrap: nowrap;
  }
  .right-container {
    flex-basis: 50%;
    flex-grow: 2;
    height: 100%;
    background: #030924;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .left-into-container{
    flex-basis: 50%;
    flex-grow: 2;
    height: 100vh;

    flex-direction: column;
    flex-wrap: nowrap;
  }
  .iframe-container {
    flex-basis: 50%;
    background: #030924;

    flex-grow: 2;
    position: relative;

  }
  .kichwa-container{
    flex-basis: 50%;
    flex-grow: 5;
    height: 100%;
    position: relative;
    background-color: #D2D2D2;
  }

  .separator {
    background: #AAA;
  }

  .separator-horizotal {
    width: 1px;
    background: transparent;
    cursor: ew-resize;
    border-right: solid 1px #AAA;
  }

  .separator-vertical {
    height: 1px;
    cursor: ns-resize;
  }
  .panel-title {
    position: absolute;
    top: 5px;
    right: 6px;
    margin: 4px;
    padding: 1px 4px 1px 5px;

    font-size: 0.85rem;

    color: gray;
    background-color: white;
    border: solid 1px rgb(209, 227, 250);
    border-radius: 4px;

    z-index: 2;
  }
  .panel-python-title {
    position: absolute;
    top: 5px;
    right: 40px;
    margin: 4px;
    padding: 1px 4px 1px 5px;

    font-size: 0.85rem;

    color: gray;
    background-color: white;
    border: solid 1px rgb(209, 227, 250);
    border-radius: 4px;

    z-index: 2;
  }
  .separator-horizotal::after,
  .separator-vertical::after {
    content: "";
    display: block;
    position: relative;
  }

  .separator-horizotal::after {
    height: 100%;
    width: 6px;
    left: -2px;
  }

  .separator-vertical::after {
    width: 100%;
    height: 6px;
    top: -2px;
  }

  .hide {
    display: none;
  }



  .option-btn {
    right: 10px;
    bottom: 10px;
    width: 40px;
    height: 40px;
    padding: 10px;

    cursor: pointer;
    transition: all 0.5s ease;
  }

  .option:hover {
    opacity: 1;
    transform: scale(1.4);
  }
  .editor-style1 {
    color: lightgray;
  }
  .my-left-scrollbar{
    width: 100%;
    height: 50%;
    background: #D2D2D2;
    min-height: 100px;
    min-width: 300px;
  }

  .my-right-scrollbar{
    width:100%;
    height: 50%;
    min-width: 300px;
    background: #D2D2D2;
    display: grid;
  }
  .my-help-scrollbar{
    width: 100%;
    height: 50%;
    min-height: 100px;
    min-width: 300px;
  }
  .my-python-code{
    margin-left: 30px;
    width: 100%;
    justify-content: center;
    flex-basis: 50%;
    flex-grow: 5;
    height: 100%;
    position: relative;
    background-color: #333;
    max-height: 800px;
    color: #91a7ff;
  }
  .my-tab-view {
    padding: 20px 0;
  }
  .my-code-view{
    height: 100%;
  }
  .bt-container{
    align-items: center;
    justify-content: center;
  }
  .doc-image{
    width: 50%;
    height: 50%;
  }
  .doc-image-ctner{
    text-align: center;
  }
  .errorTranslate{
    color: red;
    background-color: black;
  }

</style>
